var exports = {
  "kL": "x31de4314--e90ebe--container",
  "wx": "x31de4314--e90ebe--header",
  "Kk": "x31de4314--e90ebe--icon",
  "h_": "x31de4314--e90ebe--description",
  "Gq": "x31de4314--e90ebe--tooltip-content",
  "i5": "x31de4314--e90ebe--tooltip-actions",
};

module.exports = exports;
